var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-draggable",
    {
      staticClass: "border border-top",
      attrs: { y: _vm.val, "disable-x": "", "use-bottom": _vm.useBottom },
      on: {
        "update:y": function ($event) {
          _vm.val = $event
        },
      },
    },
    [_c("div")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }